import type { AuthMember } from 'api/generated/types/authMember';
import type { AuthOrganization } from 'api/generated/types/authOrganization';

export const asIdentityId = (
  value: string | null | undefined
): string | null => (value && value !== 'null' ? value : null);

/** A valid session can still need account setup before recruiter requests are safe. */
export const isAccountReady = (
  member: AuthMember | null,
  organization: AuthOrganization | null
): boolean =>
  member?.is_active === true &&
  asIdentityId(member.salv_user_id) !== null &&
  asIdentityId(organization?.salv_org_id) !== null;
